// extracted by mini-css-extract-plugin
export default {"label":"TextInput_label__VcJwV","input":"TextInput_input__wyGzw","error":"TextInput_error__R8Pv+","eye":"TextInput_eye__rxY8g"};